module.exports = __webpack_public_path__ + "img/copy-clipboard.d7962a2c.svg";